import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { mapState } from '../../map';
import { addClass, removeClass } from '../../../bgis/util/dom';
import { removeFeatureById } from '../../util';
import { FeatureLike } from 'ol/Feature';
import { selectionLayer } from '../../layers';


// Define a type for the slice state
export interface InteractState {
    hasHoverFeature: boolean, // The feature over whic is hovered.
    hasSelectedFeatures: boolean, // The currently selected features
    selectedFeatureDetail: SelectedFeatureDetail | undefined, // Whether a detail for a selected feature has to be displayed.
    selectedCount: number
}


interface SelectedFeatureDetail {
    x: number,
    y: number

}

// Initial sync back state
const initialState: InteractState = {
    hasHoverFeature: false, // The feature over whic is hovered.
    hasSelectedFeatures: false, // The currently selected features
    selectedFeatureDetail: undefined,
    selectedCount: 0
}

/**
 * Shows map details in sidebar menu.
 * @returns void
 */
const showMapDetails = () => addClass('.bgis-map-area', 'show-map-details'); // 

/**
 * Hides map details in sidebar menu.
 * @returns 
 */
const hideMapDetails = () => removeClass('.bgis-map-area', 'show-map-details')




export const interactSlice = createSlice({
    name: 'interact',
    initialState,
    reducers: {
        setSelectedFeatureCount: (state, action: PayloadAction<number>) => {
            state.selectedCount = action.payload;
            if (state.selectedCount > 0) {
                showMapDetails();
            } else {
                hideMapDetails();
            }
            selectionLayer.changed();
        },
        deleteAllSelected: (state) => {
            mapState.selectedFeatures = new Map<string, FeatureLike>();
            state.selectedCount = 0;
            if (state.selectedCount > 0) {
                showMapDetails();
            } else {
                hideMapDetails();
            }
            selectionLayer.changed();
            

        },
        deleteSelected: (state, action: PayloadAction<string>) => {
            console.log(action);
            mapState.selectedFeatures.delete(action.payload);
            state.selectedCount = mapState.selectedFeatures.size;
            if (state.selectedCount > 0) {
                showMapDetails();
            } else {
                hideMapDetails();
            }
            selectionLayer.changed();

        }

    }
});

export const { setSelectedFeatureCount, deleteAllSelected, deleteSelected } = interactSlice.actions;